// Property types icons
import LoftIcon from "./property-types/loft.svg";
import CabinIcon from "./property-types/cabin.svg";
import HouseIcon from "./property-types/house.svg";
import VillaIcon from "./property-types/villa.svg";
import RanchIcon from "./property-types/ranch.svg";
import CondoIcon from "./property-types/condo.svg";
import DuplexIcon from "./property-types/duplex.svg";
import EstateIcon from "./property-types/estate.svg";
import CastleIcon from "./property-types/castle.svg";
import ChaletIcon from "./property-types/chalet.svg";
import CottageIcon from "./property-types/cottage.svg";
import MansionIcon from "./property-types/mansion.svg";
import EcoHomeIcon from "./property-types/eco-home.svg";
import BungalowIcon from "./property-types/bungalow.svg";
import TinyHomeIcon from "./property-types/tiny-home.svg";
import FarmStayIcon from "./property-types/farm-stay.svg";
import DomeHomeIcon from "./property-types/dome-home.svg";
import TownHouseIcon from "./property-types/townhouse.svg";
import FarmHouseIcon from "./property-types/farmhouse.svg";
import PentHouseIcon from "./property-types/penthouse.svg";
import TreeHouseIcon from "./property-types/treehouse.svg";
import ApartmentIcon from "./property-types/apartment.svg";
import HouseBoatIcon from "./property-types/houseboat.svg";
import LakeHouseIcon from "./property-types/lake-house.svg";
import SkiChaletIcon from "./property-types/ski-chalet.svg";
import BeachHouseIcon from "./property-types/beach-house.svg";
import SummerVillaIcon from "./property-types/summer-villa.svg";
import FloatingHomeIcon from "./property-types/floating-home.svg";
import WindmillHomeIcon from "./property-types/windmill-home.svg";
import ContainerHomeIcon from "./property-types/container-home.svg";
import BarnConversionIcon from "./property-types/barn-conversion.svg";
import HotelApartmentIcon from "./property-types/hotel-apartment.svg";
import HotelResidenceIcon from "./property-types/hotel-residence.svg";
import StudioApartmentIcon from "./property-types/studio-apartment.svg";
import MountainChaletsIcon from "./property-types/mountain-chalets.svg";
import BeachfrontVillasIcon from "./property-types/beachfront-villas.svg";
import EstatePropertiesIcon from "./property-types/estate-properties.svg";
import ServicedApartmentIcon from "./property-types/serviced-apartment.svg";
import HighRiseApartmentIcon from "./property-types/high-rise-apartment.svg";
import ModernLuxuryHomesIcon from "./property-types/modern-luxury-homes.svg";
import GatedCommunityHomeIcon from "./property-types/gated-community-home.svg";

const PropertyTypesIconMapping = {
  loft: LoftIcon,
  house: HouseIcon,
  cabin: CabinIcon,
  ranch: RanchIcon,
  villa: VillaIcon,
  condo: CondoIcon,
  castle: CastleIcon,
  chalet: ChaletIcon,
  duplex: DuplexIcon,
  estate: EstateIcon,
  cottage: CottageIcon,
  mansion: MansionIcon,
  eco_home: EcoHomeIcon,
  bungalow: BungalowIcon,
  tiny_home: TinyHomeIcon,
  dome_home: DomeHomeIcon,
  farm_stay: FarmStayIcon,
  townhouse: TownHouseIcon,
  apartment: ApartmentIcon,
  ski_chalet: SkiChaletIcon,
  farm_house: FarmHouseIcon,
  house_boat: HouseBoatIcon,
  pent_house: PentHouseIcon,
  tree_house: TreeHouseIcon,
  lake_house: LakeHouseIcon,
  beach_house: BeachHouseIcon,
  summer_villa: SummerVillaIcon,
  windmill_home: WindmillHomeIcon,
  floating_home: FloatingHomeIcon,
  container_home: ContainerHomeIcon,
  barn_conversion: BarnConversionIcon,
  hotel_apartment: HotelApartmentIcon,
  hotel_residence: HotelResidenceIcon,
  studio_apartment: StudioApartmentIcon,
  mountain_chalets: MountainChaletsIcon,
  estate_properties: EstatePropertiesIcon,
  beachfront_villas: BeachfrontVillasIcon,
  services_apartment: ServicedApartmentIcon,
  high_rise_apartment: HighRiseApartmentIcon,
  modern_luxury_homes: ModernLuxuryHomesIcon,
  gated_community_home: GatedCommunityHomeIcon,
};

export default PropertyTypesIconMapping;
